import gql from 'graphql-tag';

export default gql`
  mutation writeContactUsInfo($input: WriteContactUsInfoRequest!) {
    writeContactUsInfo(input: $input) {
      success
      userErrors {
        field
        message
      }
      contactUsInfoList {
        contactId
      }
    }
  }
`;
